export default __webpack_public_path__ + "static/media/dblogo.8f20812d.png";